<script setup lang="ts">
import qrcode from 'qrcode-generator'
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  value: string
  label?: string
}>(), {
  label: 'QR-код',
})

const modules = computed(() => {
  if (!props.value) return [] as boolean[][]
  const code = qrcode(0, 'M')
  code.addData(props.value, 'Byte')
  code.make()
  const size = code.getModuleCount()
  return Array.from({ length: size }, (_, row) =>
    Array.from({ length: size }, (_, column) => code.isDark(row, column)),
  )
})
</script>

<template>
  <svg
    v-if="modules.length"
    class="qr-code"
    :viewBox="`0 0 ${modules.length + 8} ${modules.length + 8}`"
    role="img"
    :aria-label="label"
    shape-rendering="crispEdges"
  >
    <rect :width="modules.length + 8" :height="modules.length + 8" fill="#fff" />
    <template v-for="(row, rowIndex) in modules" :key="rowIndex">
      <rect
        v-for="(dark, columnIndex) in row"
        v-show="dark"
        :key="columnIndex"
        :x="columnIndex + 4"
        :y="rowIndex + 4"
        width="1"
        height="1"
        fill="#0b0d0c"
      />
    </template>
  </svg>
</template>
